import * as ActionTypes from "../ActionTypes.js";

export const flashReducer = (
  state = { flash: {}, lostModal: false, foundModal: false },
  action
) => {
  switch (action.type) {
    case ActionTypes.ADD_MESSAGE:
      return {
        ...state,
        flash: {
          flashType: action.payload.flashType,
          message: action.payload.message,
        },
      };
    case ActionTypes.DELETE_MESSAGE:
      return { ...state, flash: {} };

    case ActionTypes.TOGGLE_LOST_MODAL:
      return { ...state, lostModal: !state.lostModal };
    case ActionTypes.TOGGLE_FOUND_MODAL:
      return { ...state, foundModal: !state.foundModal };

    default:
      return state;
  }
};
